import { AnyAction } from 'redux';
import {
  NAVIGATION_RECEIVE,
  NAVIGATION_CURRENT_LINK,
  NAVIGATION_HIERARCHY_LINK,
} from '../constants';

interface NavigationState {
  mobileMenuOpen: boolean;
  currentLink: any;
  previousLink: any;
  desktopLinkHierarchy: any[];
  focusOnCloseElement: HTMLAnchorElement | null;
}

const DEFAULT_STATE: NavigationState = {
  mobileMenuOpen: false,
  currentLink: null,
  previousLink: null,
  desktopLinkHierarchy: [],
  focusOnCloseElement: null,
};

export const navigation = (
  state = DEFAULT_STATE,
  action: AnyAction
): NavigationState => {
  switch (action.type) {
    case NAVIGATION_RECEIVE:
    case NAVIGATION_CURRENT_LINK:
    case NAVIGATION_HIERARCHY_LINK:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
